var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-wrapper ad-facility-icons-bottom"},[_c('adsbygoogle',{attrs:{"ad-slot":"1829486257","ad-format":"auto","full-width-responsive":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }